// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__2JKeX","footer":"Features_footer__10kc1"};